import * as React from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import Autolink from 'react-native-autolink';
import type {LocationType} from 'src/types/Location';
import BackSubheader from '../../elements/BackSubheader';
import RoundedButton, {ButtonType} from '../../elements/RoundedButton';
import ScreenContext from '../../ScreenContext';
import Styles from '../../Styles';
import NavActions from 'src/actions/NavActions';
import Localized from 'src/constants/AppStrings';
import type {RouteInfo} from '../../elements/Machines';
import AppRoutes from 'src/AppRoutes';

type DisclaimerScreenProps = {
  location: LocationType;
  autoAdvanced: boolean;
  getRouteFromPickupLocations: (
    location: LocationType,
    autoAdvanced?: boolean,
  ) => Promise<RouteInfo>;
};
class DisclaimerScreen extends React.Component<DisclaimerScreenProps> {
  static contextType = ScreenContext;

  constructor(props: DisclaimerScreenProps) {
    super(props);
    this.handleContinue = this.handleContinue.bind(this);
  }

  async handleContinue() {
    const routeInfo = await this.props.getRouteFromPickupLocations(
      this.props.location,
      this.props.autoAdvanced,
    );
    if (!routeInfo.error) {
      NavActions.navigate(
        routeInfo.name as AppRoutes,
        {
          ...this.props,
          availableTimes: routeInfo.availableTimes,
        },
        'machines-pickup',
      );
    }
  }

  render() {
    return (
      <BackSubheader title={Localized.Labels.please_note}>
        <ScrollView contentContainerStyle={styles.content}>
          <Autolink
            style={styles.disclaimerText}
            text={this.props.location.disclaimer}
          />
        </ScrollView>
        <RoundedButton
          buttonType={ButtonType.action}
          onPress={this.handleContinue}
          accessibilityLabel="Continue"
          text={Localized.Buttons.continue}
        />
      </BackSubheader>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    padding: Styles.Spacing.m3,
  },
  disclaimerText: {
    marginBottom: Styles.Spacing.m5,
  },
});
export default withForwardedNavigationParams()(DisclaimerScreen);
